import React from 'react';
import PensionCalculatorPage from '../PensionCalculatorPage';
import NativeCalculator from '../NativeCalculator';
import { pensionCalculators } from '../access';
import { REDUCTION_IN_YIELD, RIY_FEE_FIELDS } from './config';

const calculator = pensionCalculators.find(item => item.id === 'reduction-in-yield');
const config = {
  ...REDUCTION_IN_YIELD,
  labels: Object.fromEntries(RIY_FEE_FIELDS),
  note: 'A simple fee estimate: annual product, fund and adviser fees plus the one-off initial fee spread evenly over the term. It does not model compounded cash flows or investment growth.',
};

export default function ReductionInYieldPage() {
  return (
    <PensionCalculatorPage calculator={calculator}>
      <NativeCalculator calculator={calculator} config={config} />
    </PensionCalculatorPage>
  );
}
